import Login from './Login';
import System from './System';
import Agent from './Agent';

//import LogDetail from './Log.Detail';

const Logs = {
  Login, System, Agent,
}
export default Logs
export {
  Login, System, Agent,
}
